import { Box, Grid, Card, Typography } from "@mui/material";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import GroupIcon from "@mui/icons-material/Group";
import MoneyIcon from "@mui/icons-material/Money";
import Translate from "../../utils/Translate";
import DotMenu from "../DotMenu";
import { formatMoney } from "../../utils/formatMoney";
import { hasAccess, accessKeys } from "../../utils/userAccess";
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';

export default function ClassRoomCard({
  description,
  noDays,
  maxParticipants,
  validTimeValue,
  validTimeDefinition,
  price,
  extraActions,
}) {
  return (
    <Card
      sx={{ padding: "16px", marginBottom: "16px", transform: "translateZ(0)" }}
    >
      <Typography variant="h6" sx={{ marginTop: "6px", marginLeft: "12px" }}>
        {description}
      </Typography>
      <Box sx={{ position: "fixed", top: "18px", right: "16px" }}>
        <DotMenu content={extraActions} horizontal />
      </Box>
      <Grid
        container
        spacing={4}
        direction="column"
        sx={{ padding: "30px 0px 16px 18px" }}
      >
        <Grid item container alignItems="center">
          <MeetingRoomIcon />
          <Box marginLeft="19px">{noDays}</Box>
        </Grid>
        <Grid item container alignItems="center">
          <GroupIcon />
          <Box marginLeft="19px">{maxParticipants}</Box>
        </Grid>
        <Grid item container alignItems="center">
          <EventAvailableIcon />
          <Box marginLeft="19px">
            {validTimeValue
              ? `${validTimeValue} ${Translate.getValidTimeDefinition(
                  validTimeDefinition
                )}`
              : ""}
          </Box>
        </Grid>
        {hasAccess(accessKeys.iframe) && (
          <Grid item container alignItems="center">
            <MoneyIcon />
            <Box marginLeft="19px">{formatMoney(price)}</Box>
          </Grid>
        )}
      </Grid>
    </Card>
  );
}
